/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Sign_Verify_Email_TipInputs */

const en_common_sign_verify_email_tip = /** @type {(inputs: Common_Sign_Verify_Email_TipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`After verifying, click "Continue".`)
};

const zh_common_sign_verify_email_tip = /** @type {(inputs: Common_Sign_Verify_Email_TipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`完成验证后，请点击「继续」按钮。`)
};

/**
* | output |
* | --- |
* | "After verifying, click \"Continue\"." |
*
* @param {Common_Sign_Verify_Email_TipInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const common_sign_verify_email_tip = /** @type {((inputs?: Common_Sign_Verify_Email_TipInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Sign_Verify_Email_TipInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_common_sign_verify_email_tip(inputs)
	return zh_common_sign_verify_email_tip(inputs)
});
export { common_sign_verify_email_tip as "common.sign.verify_email_tip" }